import { DemoExample } from "@/components/sections/DemoSection";

export const skyReplacementDemo: DemoExample = {
    label: "Sky Replacement",
    beforeImage: "/images/demos/sky/sky-before.webp",
    beforeImageSrcSet: "/images/demos/sky/sky-before-400w.webp 400w, /images/demos/sky/sky-before-800w.webp 800w",
    afterImage: "/images/demos/sky/sky-after.webp",
    afterImageSrcSet: "/images/demos/sky/sky-after-400w.webp 400w, /images/demos/sky/sky-after-800w.webp 800w",
    title: "Replace Overcast Sky with Sunset",
    description: "Transform boring gray skies into dramatic golden sunsets.",
    alt: "Before and after replacing cloudy sky with vibrant sunset"
};

export const sunsetSkyDemo: DemoExample = {
    label: "Sunset Sky",
    beforeImage: "/images/demos/sky/sky-before.webp",
    afterImage: "/images/demos/sky/sky-sunset.webp",
    title: "Golden Hour Sunset",
    description: "Add warm, dramatic sunset colors to your photos.",
    alt: "Before and after sunset sky replacement"
};

export const blueSkyDemo: DemoExample = {
    label: "Blue Sky",
    beforeImage: "/images/demos/sky/sky-before.webp",
    afterImage: "/images/demos/sky/sky-blue.webp",
    title: "Perfect Blue Sky",
    description: "Replace gray clouds with a bright, sunny blue sky.",
    alt: "Before and after blue sky replacement"
};

export const stormySkyDemo: DemoExample = {
    label: "Stormy Sky",
    beforeImage: "/images/demos/sky/sky-before.webp",
    afterImage: "/images/demos/sky/sky-stormy.webp",
    title: "Dramatic Storm",
    description: "Create a moody atmosphere with dark, stormy clouds.",
    alt: "Before and after stormy sky replacement"
};
